import React from 'react';
import SMOwnerResource from 'resources/SMOwnerResource';

class SMOICalendarUrlView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      iCalUrl: "",
    };
  }

  componentDidMount() {
    SMOwnerResource.getRoom(this.props.owner.id, this.props.roomId, (response, error, xhr)=>{
      this.setState({
        iCalUrl: response.ical_export_url,
      });
    });
  }

  formDidSubmit(e) {
    e.preventDefault();
    $(document).trigger("SMHideDialog");
  }

  urlSelectHandler(e) {
    e.target.select();
  }

  render() {
    return(
      <div className="maincol-lightbox">
        <div className="form-casette maincol-lightbox__form">
          <form onSubmit={this.formDidSubmit.bind(this)}>

            <h2 className="dashboard-title mb20">
              {I18n.t("dashboard.label_000206")}
              <span className="dashboard-title__supplement mr15 ml10">
                {I18n.t("dashboard.label_000207")}
              </span>
            </h2>
            <div className="mt50">
              <h3 className="dashboard-title2 ta-c">{I18n.t('dashboard.label_000208')}</h3>
              <p className="mt10 mb30">
                <input type="text" className="form-text w780 mr10" value={this.state.iCalUrl} readOnly onClick={this.urlSelectHandler.bind(this)} />
              </p>
            </div>
            <div className="ta-c mb50">
              <input className="button-gray pt10 pb10 w100 mr5" type="submit" value={I18n.t('dashboard.label_000309')} />
            </div>

            <a href="#" className="form-casette__close" onClick={this.formDidSubmit.bind(this)}><i className="fa fa-times"></i></a>

          </form>
        </div>
      </div>
    );
  }
}
export default SMOICalendarUrlView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOICalendarUrlView.jsx